import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeletePhotoConfirmDialogProps {
  pendingDeleteUrl: string | null;
  isDeletingPhoto: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeletePhotoConfirmDialog({
  pendingDeleteUrl,
  isDeletingPhoto,
  onCancel,
  onConfirm,
}: DeletePhotoConfirmDialogProps) {
  return (
    <AlertDialog
      open={!!pendingDeleteUrl}
      onOpenChange={(o) => {
        if (!o && !isDeletingPhoto) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this photo?</AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes the photo from this listing. If it was your proof photo, that designation will also be cleared.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeletingPhoto}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isDeletingPhoto}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeletingPhoto ? 'Deleting…' : 'Delete photo'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
